export default function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/invariant.mjs
// module id = 83
// module chunks = 4